module.exports = __webpack_public_path__ + "img/小雪.a4a4cec5.png";